__turbopack_context__.v({
  "container": "ZoUf7q_container",
  "height--tall": "ZoUf7q_height--tall",
  "label": "ZoUf7q_label",
  "value": "ZoUf7q_value",
});
